import { render, staticRenderFns } from "./ProdEditor.vue?vue&type=template&id=7f9c37ba&scoped=true&"
import script from "./ProdEditor.vue?vue&type=script&lang=js&"
export * from "./ProdEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProdEditor.vue?vue&type=style&index=0&id=7f9c37ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9c37ba",
  null
  
)

export default component.exports